/**
 * רצועת גוון נחושת עם חיתוך אלכסוני — כיוון עיצוב "ג' - לוחות א-סימטריים"
 * (נבחר על ידי אריאנה 16.08.2026, ראו TASKS 6.4 המשך).
 *
 * ⭐ לבקשת אריאנה 16.08.2026 - זהה בכל הדפים הראשיים בניווט (בית · קטלוג ·
 * מחשבון מ"ר · אודות · צור קשר בזמנו), ⛔ לא רק בדף הבית. מרוכז ברכיב אחד
 * כדי שהזהות הוויזואלית באמת תישאר זהה בכולם, ⛔ לא כמה עותקים שעלולים
 * לסטות.
 * ⚠️ **עדכון 19.08.2026:** דף המחשבון עצמו הוסר (Feedback1.md סעיף 5) —
 * הרשימה נשארת כתיעוד היסטורי של למה הרכיב נוצר, ⛔ לא רשימת הדפים החיה.
 */
import type { ReactNode } from 'react';

interface TintedSectionProps {
  children: ReactNode;
}

export function TintedSection({ children }: TintedSectionProps) {
  return (
    <>
      <div className="section-fold-in" aria-hidden="true" />
      <div className="section-tint">{children}</div>
      <div className="section-fold-out" aria-hidden="true" />
    </>
  );
}
